import React, { Component } from "react";
import { connect } from "react-redux";
import EmployeeCardComponent from "../../components/ProfileCard/ProfileCard";
import * as URLs from "../../../../common/constants/systemUrls";
import * as profileCardActions from "../../redux/actions/profileCard";
import { interfaceActions } from "../../../../common/redux/actions";
import history from "../../../../common/history";
import showConfirmWindow from "../../../../common/components/confirmPopup/confirmPopup";
import { confirmEditProfile } from "../../components/ProfileCard/popup/confirm";
import progresses from "./FormProgress/progresses";
const { setCaption } = interfaceActions;

//Actions
const {
  getEmployee,
  updateEmployee,
  createEmployee,
  createEmployeeClearError,
  updateEmployeeStatus,
  getCheckUserByPhoneNumber,
  getCheckUserByPhoneNumberSuccess
} = profileCardActions;

function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}

class ProfileCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileId: this.getProfileId(),
      visibleExcludeVehicles: false,
      visibleDriverOrders: false,
      isEditable: false,
      userRole: null,
      userRoleId: null,
      userRoleInEditForm: null,
      userIsDriver: false, // При просмотре профиля
      userIsDriverInEditForm: false, // При редактировании профиля
      formErrors: {
        profileCard: false
      },
      formProgress: [...progresses.role, ...progresses.phone],
      checkPhone: false
    };

    if (this.state.profileId === 0) {
      this.state.isEditable = true;
    }

    this.defaultProfileData = {
      role: null,
      roleId: null,
      roleKey: null
    };

    const userRole = this.getUserRoleProps();
    this.state.userRole = userRole.userRole;
    this.state.userIsDriver = userRole.userIsDriver;

    this.forms = {};

    this.updateSetCaption = true;
  }

  checkFormErrors = formName => {
    const form = this.getForm(formName);
    if (form) {
      let err = hasErrors(form.getFieldsError());
      if (this.state.formErrors[formName] !== err) {
        this.setState(() => ({
          formErrors: {
            ...this.state.formErrors,
            [formName]: err
          }
        }));
      }
    }
  };

  formSubmit = name => {
    const form = this.getForm(name);
    if (form) {
      // e.preventDefault();
      form.validateFields((err, fieldsValue) => {
        // console.log(err, fieldsValue);
        if (err) {
          return false;
        }

        // Отправка формы
        if (name === "profileCard") {
          let data = {
            ...fieldsValue,
            profileId: this.state.profileId
          };

          if (this.state.profileId === 0) {
            this.props.createEmployee(data);
          } else {
            // todo изменить цвет иконки вопросика на серый
            showConfirmWindow({
              ...confirmEditProfile,
              onOk: () => {
                this.props.updateEmployee(data);
              }
            });
          }
        }
      });
    } else {
      console.log("Error", name);
    }
  };

  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };

  // Закрыть окно загрузки водителя
  handleClickDriverOrdersHide = () => {
    this.setState((state, props) => ({
      visibleDriverOrders: false
    }));
  };

  // Показать окно загрузку водителя
  handleClickDriverOrdersShow = () => {
    this.setState((state, props) => ({
      visibleDriverOrders: true
    }));
  };

  // Закрыть окно "Исключить ТС"
  handleClickExcludeVehiclesHide = () => {
    this.setState((state, props) => ({
      visibleExcludeVehicles: false
    }));
  };

  // Показать окно "Исключить ТС"
  handleClickExcludeVehiclesShow = () => {
    this.setState((state, props) => ({
      visibleExcludeVehicles: true
    }));
  };

  // Исключить выбранные ТС
  // !!!! Как будут реальные данные реализовать функционал /
  handleClickExcludeVehicles = e => {
    this.setState((state, props) => ({
      // visible_excluded_ts: e.length > 0 && false || true,
      data: {
        ...state.data,
        excluded_ts: e
      }
    }));
  };

  handleClickEditEmployee = () => {
    this.setState((state, props) => ({
      isEditable: true
    }));
  };

  handleClickCloseEditing = () => {
    if (this.state.profileId === 0) {
      history.push("/" + URLs.EMPLOYEES);
    } else {
      this.setState((state, props) => ({
        isEditable: false
      }));
    }
  };

  handleClickUpdateProfileStatus = status => {
    this.props.updateEmployeeStatus({
      employeeId: this.state.profileId,
      status
    });
  };

  getUserRoleProps() {
    const profileData = this.getProfileData();
    if (profileData) {
      const { role, roleId, roleKey } = this.getProfileData();
      return {
        userRole: role,
        userRoleId: roleId,
        userIsDriver: roleKey === "driver"
      };
    } else {
      return {
        userRole: null,
        userRoleId: null,
        userIsDriver: false
      };
    }
  }
  // Устанавливаем роль при изменении пропсов
  updateUserRole = () => {
    const userRoleProps = this.getUserRoleProps();
    const { userRole, userIsDriver } = this.state;

    if (
      userRoleProps.userRole !== userRole ||
      userRoleProps.userIsDriver !== userIsDriver
    ) {
      this.setState((state, props) => ({
        userRole: userRoleProps.userRole,
        userIsDriver: userRoleProps.userIsDriver
      }));
    }
  };

  changePhone = e => {
    if (this.state.profileId === 0) {
      const form = this.getForm("profileCard");
      if (form) {
        const phone = form.getFieldsValue(["phone", "phoneCode"]);
        if (phone.phoneCode && phone.phone && phone.phone.length > 9) {
          const phoneNew = `${phone.phoneCode}${phone.phone}`;
          if (
            !(
              this.props.checkUserByPhoneNumber &&
              this.props.checkUserByPhoneNumber.phone === phoneNew
            )
          ) {
            this.props.getCheckUserByPhoneNumber(phoneNew);
          }
        }
      }
    }
  };

  handleChangeProgress = () => {
    const form = this.getForm("profileCard");
    if (form) {
      const roleKey = form.getFieldValue("roleKey");
      const phone = form.getFieldsValue(["phone", "phoneCode"]);
      const checkPhone =
        phone.phoneCode &&
        phone.phone &&
        phone.phone.length > 9 &&
        this.props.checkUserByPhoneNumber &&
        this.props.checkUserByPhoneNumber.phone ===
          `${phone.phoneCode}${phone.phone}` &&
        this.props.checkUserByPhoneNumber.status === "notExist";
      if (
        this.state.userRoleInEditForm !== roleKey ||
        this.state.checkPhone !== checkPhone
      ) {
        this.setState(
          state => {
            let formProgress;
            // todo из-за того что полностью меняется объект и потом только проверяется на валидность, есть скачки в прогресс баре
            if (this.state.profileId === 0) {
              formProgress = [
                ...progresses.role,
                ...progresses.phone,
                ...(checkPhone && roleKey !== "driver"
                  ? progresses.default
                  : [])
              ];
            } else {
              formProgress = [
                ...progresses.role,
                ...progresses.phone,
                ...(roleKey === "driver"
                  ? progresses.editDriver
                  : progresses.default)
              ];
            }
            return {
              formProgress,
              userRoleInEditForm: roleKey,
              checkPhone,
              userIsDriverInEditForm: roleKey === "driver" // todo уже возможно лишнее нужно решить выкинуть или оставить
            };
          },
          () => {
            // обновляем валидацию формы, иначе будет косяк с прогрессом заполнения формы
            const form = this.getForm("profileCard");
            if (form) {
              form.validateFields((err, values) => {
                this.updateProgress(values);
              });
            }
          }
        );
      }
    }
  };

  // При изменении роли в форме редактирования влияет на интерфейс страницы
  handleChangeUserRoleInEditForm = roleKey => {
    this.handleChangeProgress();
    /*
    this.setState(
      (state, props) => {
        let formProgress = [];
        if (roleKey && state.userRoleInEditForm !== roleKey) {
          switch (roleKey) {
            case 'driver':
              formProgress = [
                ...progresses.all,
                ...(state.profileId === 0
                  ? progresses.addDriver
                  : progresses.editDriver),
              ];
              break;
            default:
              formProgress = [...progresses.all, ...progresses.default];
          }
        } else {
          formProgress = state.formProgress;
        }
        return {
          formProgress,
          userRoleInEditForm: roleKey,
          userIsDriverInEditForm: roleKey === 'driver', // todo уже возможно лишнее нужно решить выкинуть или оставить
        };
      },
      () => {
        // обновляем валидацию формы, иначе будет косяк с прогрессом заполнения формы
        const form = this.getForm('profileCard');
        if (form) {
          form.validateFields((err, values) => {
            this.updateProgress(values);
          });
        }
      }
    );
    */
  };

  // Обновление прогресса заполнения
  updateProgress = values => {
    setTimeout(() => {
      // todo разобраться в последовательности вызовов, без этого рушится прогресс заполнения
      const form = this.getForm("profileCard");
      if (form) {
        let newFormProgress = null;
        let checkAll = true;
        Object.keys(values).forEach(name => {
          this.state.formProgress.forEach((step, index) => {
            if (
              step.fields &&
              step.fields.some(fieldName => fieldName === name) &&
              step.check
            ) {
              const fieldsValue = form.getFieldsValue(step.fields);
              const check = step.check(fieldsValue, form);
              if (!newFormProgress)
                newFormProgress = [...this.state.formProgress];
              newFormProgress = [
                ...newFormProgress.slice(0, index),
                {
                  ...newFormProgress[index],
                  name: step.name,
                  completed: check,
                  fieldsValue: fieldsValue
                },
                ...newFormProgress.slice(index + 1)
              ];
              if (checkAll && !check) {
                if (step.button !== false) checkAll = false;
              }
            }
          });
        });

        if (newFormProgress) {
          if (checkAll) {
            // Если все изменённые поля успешно прошли проверку
            // делаем полную проверку по всем группам
            // если button = false тогда он не участвует в проверке для кнопки отправки.
            // если в прогрессе нет ключа button то по умолчанию он равен true
            checkAll = newFormProgress.every(({ completed, button = true }) =>
              button ? completed : true
            );
          }
          this.setState({
            formProgress: newFormProgress,
            disabledSaveButton: !checkAll
          });
        }
      }
    }, 0);
  };
  /*
  // Обновление прогресса заполнения
  updateProgress = values => {
    const form = this.getForm('profileCard');
    if (form) {
      let updateProgress = [];
      Object.keys(values).forEach(name => {
        // Ищем к какой группе относится измененное поле
        let progressItem = this.state.formProgress.find(progress => {
          let result = false;
          // Проходимся по обязательным полям
          if (progress.fields) {
            let fields = Array.isArray(progress.fields[0])
              ? progress.fields
              : [progress.fields];

            result = fields.some(groups =>
              groups.some(groupFields => groupFields.indexOf(name) !== -1)
            );
            if (result) return result;
          }
          // Если не нашли в обязательных полях просматриваем в полях для descriptions
          if (!result && progress.fieldsDesc) {
            return progress.fieldsDesc.some(
              groupFields => groupFields.indexOf(name) !== -1
            );
          }
          return false;
        });

        // Если нашли группу, начинаем проверять поля на заполненность
        if (progressItem) {
          let description, fieldsValue;

          // Проверяем обязательные поля на наличие ошибок
          let groupСompleted = false;

          let groupFields = Array.isArray(progressItem.fields[0])
            ? progressItem.fields
            : [progressItem.fields];
          groupFields.forEach(fields => {
            if (!groupСompleted) {
              groupСompleted = !hasErrors(form.getFieldsError(fields));
              if (groupСompleted) {
                // Группа без ошибок
                // Проверяем на наличие пустых значений
                fieldsValue = form.getFieldsValue(fields);
                if (
                  Object.keys(fieldsValue).some(field =>
                    Array.isArray(fieldsValue[field])
                      ? fieldsValue[field].length === 0
                      : !fieldsValue[field]
                  )
                ) {
                  groupСompleted = false; // В группе есть незаполненные поля, которые являются обязательными
                }
              }
            }
          });

          // Если группа без ошибок, сохраняем данные для description
          if (groupСompleted) {
            fieldsValue =
              (progressItem.fieldsDesc &&
                form.getFieldsValue(progressItem.fieldsDesc)) ||
              fieldsValue;
            description = Object.keys(fieldsValue).reduce((desc, name) => {
              return desc + (desc !== '' ? ', ' : '') + fieldsValue[name];
            }, '');
          }

          updateProgress.push({
            name: progressItem.name,
            completed: groupСompleted,
            fieldsValue,
            description,
          });
        }
      });

      if (updateProgress.length > 0) {
        this.setState((state, props) => {
          let { formProgress } = state;
          let newFormProgress = [...formProgress];
          let flagUpdate = false;
          updateProgress.forEach(group => {
            const itemIndex = newFormProgress.findIndex(
              item => item.name === group.name
            );
            if (
              itemIndex !== -1 &&
              (newFormProgress[itemIndex].completed !== group.completed ||
                newFormProgress[itemIndex].description !== group.description)
            ) {
              flagUpdate = true;
              newFormProgress = [
                ...newFormProgress.slice(0, itemIndex),
                Object.assign({}, newFormProgress[itemIndex], group),
                ...newFormProgress.slice(itemIndex + 1),
              ];
            }
          });
          if (flagUpdate) {
            return { formProgress: newFormProgress };
          } else {
            return {};
          }
        });
      }
    }
  };
*/
  componentDidMount() {
    this.setCaption();
    if (this.state.profileId > 0) {
      // Если данных в store нет, загружаем с сервера
      if (!this.props.profileCards["id" + this.state.profileId]) {
        this.props.getEmployee(this.state.profileId);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.updateUserRole(); // Обновляем роль пользователя если она изменилась. Влияет на страницу просмотра профиля
    // Смотрим не сменился ли ProfileId
    this.updateProfileId();
    this.setCaption();

    if (
      prevProps.checkUserByPhoneNumber !== this.props.checkUserByPhoneNumber
    ) {
      this.handleChangeProgress();
    }

    // Закрывает редактирование после успешного обновления
    if (
      this.state.isEditable &&
      this.props.updateSuccess !== prevProps.updateSuccess
    ) {
      this.handleClickCloseEditing();
    }
  }

  setCaption() {
    if (this.updateSetCaption) {
      const userData = this.getProfileData();
      let title = "";
      if (this.state.profileId === 0) {
        title = "Добавить сотрудника";
      } else {
        if (userData) {
          title =
            userData.lastname && userData.name && userData.patronymic
              ? userData.lastname +
                " " +
                userData.name +
                " " +
                userData.patronymic
              : userData.phoneMask;
        }
      }

      if (title) {
        this.updateSetCaption = false;
        this.props.setCaption({
          enabled: true,
          mainCaption: userData
            ? userData.lastname && userData.name && userData.patronymic
              ? title
              : title + " (Запрос отправлен)"
            : title,
          breadCrumbs: [
            {
              path: "/" + URLs.CONTROL_PANEL,
              breadcrumbName: "Панель управления"
            },
            { path: "/" + URLs.EMPLOYEES, breadcrumbName: "Сотрудники" },
            { path: "/" + URLs.EMPLOYEES, breadcrumbName: title }
          ]
        });
      }
    }
  }

  updateProfileId() {
    const profileId = this.getProfileId();
    if (profileId !== this.state.profileId) {
      this.updateSetCaption = true;
      this.setState((state, props) => ({
        profileId: profileId,
        isEditable: profileId === 0 ? true : state.isEditable
      }));
    }
  }

  // Вытаскиваем ProfileId если он равняется 'add' возвращаем 0 добавление нового профайла
  getProfileId() {
    const { id = 0 } = this.props.match && this.props.match.params;
    return id > 0 ? id : 0;
  }

  getProfileData() {
    return (
      (this.state.profileId > 0 &&
        this.props.profileCards["id" + this.state.profileId]) ||
      null
    );
  }

  getProfileDataErr() {
    //if (this.state.profileId === 0) {
    // todo привести в единый стиль create + update
    if (this.props.profileCreateErr && this.props.profileCreateErrData) {
      return this.props.profileCreateErrData;
    }
    //}
    return null;
  }

  render() {
    return (
      <EmployeeCardComponent
        {...this.props}
        {...this.state}
        profileData={this.getProfileData()}
        profileDataErr={this.getProfileDataErr()}
        handleClickDriverOrdersHide={this.handleClickDriverOrdersHide}
        handleClickDriverOrdersShow={this.handleClickDriverOrdersShow}
        handleClickExcludeVehiclesHide={this.handleClickExcludeVehiclesHide}
        handleClickExcludeVehiclesShow={this.handleClickExcludeVehiclesShow}
        handleClickExcludeVehicles={this.handleClickExcludeVehicles}
        handleClickEditEmployee={this.handleClickEditEmployee}
        handleClickCloseEditing={this.handleClickCloseEditing}
        handleClickUpdateProfileStatus={this.handleClickUpdateProfileStatus}
        handleChangeUserRoleInEditForm={this.handleChangeUserRoleInEditForm}
        updateProgress={this.updateProgress}
        changePhone={this.changePhone}
        setForm={this.setForm}
        getForm={this.getForm}
        checkFormErrors={this.checkFormErrors}
        formSubmit={this.formSubmit}
      />
    );
  }
}

export default connect(
  state => ({
    // CRUD data
    checkUserByPhoneNumber: state.Employees.profileCard.checkUserByPhoneNumber,
    profileCards: state.Employees.profileCard.data,
    profileCreateErr: state.Employees.profileCard.createErr,
    profileCreateErrData: state.Employees.profileCard.createErrData,
    activeProfile: state.Authorization.activeProfile.profileId,
    // Filter fields data
    // UI data
    isLoading: state.Employees.profileCard.isLoading,
    updateSuccess: state.Employees.profileCard.updateSuccess
  }),
  {
    setCaption,
    // CRUD METHODS
    getEmployee,
    updateEmployee,
    createEmployee,
    updateEmployeeStatus,
    getCheckUserByPhoneNumber,
    getCheckUserByPhoneNumberSuccess, // todo для теста пока нет апи
    // GET FIELDS METHODS
    // UI METHODS
    //
    createEmployeeClearError
  }
)(ProfileCard);
